import { useAuth } from 'context/authentication/useAuth'
import { useFeatureFlagService } from '../utils/useFeatureFlagService'

export function useHasUnlimitedCredits(): boolean {
  const { user } = useAuth()
  const { enableContactCredits } = useFeatureFlagService()
  const activateType = user?.company?.activate_type ?? 'none'
  return activateType === 'full' || !enableContactCredits
}
